import { Component, Input } from '@angular/core';
import {
    CallAiAssistState,
    CallAiPriceMatch,
    CallAiTranscriptLine,
    CallDataType
} from '../../../state';
import { Store } from '../../../store';
import { TwilioService } from '../../../services/twilio.service';

@Component({
    selector: 'app-call-ai-assist',
    templateUrl: './call-ai-assist.component.html',
    styleUrls: ['./call-ai-assist.component.scss'],
})
export class CallAiAssistComponent {
    @Input() compact = false;

    callDetails$ = this.store.select<CallDataType>('call');

    constructor(
        public store: Store,
        public twilioService: TwilioService
    ) {}

    getStatusLabel(aiAssist: CallAiAssistState): string {
        if (aiAssist?.status === 'listening') {
            return 'Listening';
        }
        if (aiAssist?.status === 'matching') {
            return 'Matching';
        }
        if (aiAssist?.status === 'ready') {
            return 'Ready';
        }
        if (this.twilioService.isLineBusy) {
            return 'Warming up';
        }
        return 'Idle';
    }

    getIntentLabel(intent: string): string {
        return intent ? intent.replace(/_/g, ' ') : 'general call';
    }

    getConfidenceLabel(confidence: number | null): string {
        return confidence === null || confidence === undefined ? '' : `${Math.round(confidence * 100)}%`;
    }

    getOrderCount(orders: any): number {
        return Array.isArray(orders) ? orders.length : 0;
    }

    getTopOrders(orders: any): Array<any> {
        return Array.isArray(orders) ? orders.slice(0, 2) : [];
    }

    getTranscriptLines(aiAssist: CallAiAssistState): Array<CallAiTranscriptLine> {
        return aiAssist?.transcript?.filter(line => line?.text)?.slice(-3) || [];
    }

    getPriceMatches(aiAssist: CallAiAssistState): Array<CallAiPriceMatch> {
        return aiAssist?.priceMatches?.slice(0, 2) || [];
    }

    getSuggestedReply(callDetails: CallDataType): string {
        if (callDetails?.aiAssist?.suggestedReply) {
            return callDetails.aiAssist.suggestedReply;
        }

        if (this.getOrderCount(callDetails?.orders) > 0) {
            return 'Confirm the product or order line before quoting anything new.';
        }

        return 'Confirm product, size, quantity and delivery postcode before giving a price.';
    }
}
